<template>
    <div>
        Seite nicht gefunden
    </div>
</template>

<script>
    export default {
        name: 'notFound',
        mounted: function() {
            this.$router.push("/");
        }
    }
</script>

<style scoped>

</style>